
import React from 'react'
import Chart from 'react-apexcharts'
import { COLORS } from './chart.constant'

const BasicColumn = () => {
    const data = [
        {
            name: 'Orlando',
            data: [3600, 2700, 2800, 2500, 3600, 3580, 3300, 3640, 3800],
        },
        {
            name: 'New York City',
            data: [3800, 4657, 5555, 5700, 4720, 5820, 4985, 6007, 3507],
        },
        {
            name: 'Brooklyn',
            data: [1854, 2578, 3507, 2655, 4108, 4525, 4102, 4522, 3552],
        },
    ]

    return (
        <Chart
            options={{
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '55%',
                        endingShape: 'rounded',
                    },
                },
                colors: COLORS,
                dataLabels: {
                    enabled: false,
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ['transparent'],
                },
                xaxis: {
                    categories: [
                        'Dec',
                        'Jan',
                        'Feb',
                        'Mar',
                        'Apr',
                        'May',
                        'Jun',
                        'Jul',
                        'Aug',
                    ],
                },
                fill: {
                    opacity: 1,
                },
                tooltip: {
                    y: {
                        formatter: (val) => `$${val}.00`,
                    },
                },
            }}
            series={data}
            height={300}
            width={500}
            type="bar"
        />
    )
}

export default BasicColumn

